module.exports = __webpack_public_path__ + "media/Images/plan-401k-header-image-6dc74b7a1378d03a95dad7836ebbd3c6.jpg";